import { PHONE_NUMBER_CODE_LV, PHONE_NUMBER_CODE_LT, PHONE_NUMBER_CODE_FI, PHONE_NUMBER_CODE_EE } from '@/constants/common/constants';

export const isLvCode = (phoneNumber: string): boolean =>
  phoneNumber.startsWith(PHONE_NUMBER_CODE_LV);

export const isLtCode = (phoneNumber: string): boolean =>
  phoneNumber.startsWith(PHONE_NUMBER_CODE_LT);

export const isEeCode = (phoneNumber: string): boolean =>
  phoneNumber.startsWith(PHONE_NUMBER_CODE_EE);

export const isFiCode = (phoneNumber: string): boolean =>
  phoneNumber.startsWith(PHONE_NUMBER_CODE_FI);
